import { SpinnerService } from './../services/spinner.service';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { NotificationService } from '../services/notification.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

 // spinnerService: SpinnerService;
  constructor(
    private injector: Injector,
    //private  spinnerService : SpinnerService
  ) {
   // this.spinnerService = this.injector.get(SpinnerService);
  }

  handleError(globalError: Error | HttpErrorResponse) {
    const notificationService = this.injector.get(NotificationService);
    const spinnerService = this.injector.get(SpinnerService);

    const router = this.injector.get(Router); 
    //this.spinnerService.hideAll();
   // debugger;
    console.log("globalError : " ,globalError);
    if (globalError instanceof HttpErrorResponse) {
      // Server error happened
      if (!navigator.onLine) {
        // No Internet connection
        notificationService.smallBoxError('No Internet Connection');
      }
      // Http Error
      globalError.error.messages.forEach(message => {
        notificationService.serverErrorMessage(`${globalError.status} - ${message}`);
      });
    } else {
      // Client Error Happend
      router.navigate(['/error'], { queryParams: { error: globalError } });
    }
    //console.log("antes del spiner");
    spinnerService.hideAll();
    //console.log("despues del spiner");
    // Log the error anyway
  }
}




// WEBPACK FOOTER //
// ./src/app/core/handlers/GlobalErrorHandler.ts